module.exports = __webpack_public_path__ + "img/skype.1bfae989.jpg";